export function extractCreatedModuleId(createResponse) {
  // Backend currently returns updated pageRows; we infer created id as last row/last module.
  // This is intentionally isolated so it can be improved later without touching save logic.
  if (!createResponse?.pageRows || createResponse.pageRows.length === 0) return null;

  const lastRow = createResponse.pageRows[createResponse.pageRows.length - 1];
  const lastModules = lastRow?.pageModules;
  if (!Array.isArray(lastModules) || lastModules.length === 0) return null;

  const createdModule = lastModules[lastModules.length - 1];
  return createdModule?.id ?? null;
}
